import { render } from "./_details.vue?vue&type=template&id=1a2f55ce&scoped=true&lang=pug"
import script from "./_details.vue?vue&type=script&lang=js"
export * from "./_details.vue?vue&type=script&lang=js"

import "./_details.vue?vue&type=style&index=0&id=1a2f55ce&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2f55ce"]])

export default __exports__